export default function () {
  return {
    src: String,
    imgHeight: {
      type: String,
      default: ''
    },
    imgWidth: {
      type: String,
      default: ''
    },
    isLink: Boolean,
    mainTitle: '',
    remark: '',
    status: '',
    subTitle: '',
    rightTitle: '',
    customClass: '',
    link: [String, Object],
    userInterface: Boolean,
    content: String
  }
}



// WEBPACK FOOTER //
// ./src/components/common/panel-item/props.js